export enum enmFactSheetFileSizeType {
  Thumbnail, Small, Smaller, Logo, Medium, Large, Custom, Web, AgencyLogo
}
